// extracted by mini-css-extract-plugin
export default {"RegisterContainer":"Register_RegisterContainer__dJM3Q"};